/**
 * Created by Kevin Dench on 6/15/2016.
 */

/* @ngInject */
export default function ContainerInfoApiService($resource, $http, __env) {
    return {
        getContainerInfo: function (callBack, callBackError) {
            $http({method: 'GET', url: `${__env.intellidataApiUrl}status/resources?resourceTypes=PNF,CONTAINER`})
                .then(({data}) => {
                    callBack(data);
                })['catch'](callBackError);
        },

        getDisplayName: function (multiDisplayable, language) {
            if (multiDisplayable.displayNames === undefined || multiDisplayable.displayNames === null) {
                return null;
            }

            let j;
            switch (language) {
                // Will always have an english version
                case 'ENGLISH' :
                    for (j = 0; j < multiDisplayable.displayNames.length; ++j) {
                        if (multiDisplayable.displayNames[j].language === 'ENGLISH') {
                            return multiDisplayable.displayNames[j].display;
                        }
                    }
                    break;
                case 'JAPANESE' :
                    if (multiDisplayable.displayNames.length > 1) {
                        for (j = 0; j < multiDisplayable.displayNames.length; ++j) {
                            // Try for a Japanese display name first
                            if (multiDisplayable.displayNames[j].language === language) {
                                return multiDisplayable.displayNames[j].display;
                            }
                        }
                    } else {
                        // May not always have Japanese language, so just return the english one
                        return multiDisplayable.displayNames[0].display;
                    }
                    break;
                default:
                    for (j = 0; j < multiDisplayable.displayNames.length; ++j) {
                        if (multiDisplayable.displayNames[j].language === 'ENGLISH') {
                            return multiDisplayable.displayNames[j].display;
                        }
                    }
            }

            return null;
        },
        getDisplayNameByDisplayNames: function (displayNames, language) {
            if (displayNames === undefined || displayNames === null) {
                return null;
            }
            let j;
            switch (language) {
                case 'ENGLISH' :
                    for (j = 0; j < displayNames.length; ++j) {
                        if (displayNames[j].language === language) {
                            return displayNames[j].display;
                        }
                    }
                    break;
                case 'JAPANESE' :
                    if (displayNames.length > 1) {
                        for (j = 0; j < displayNames.length; ++j) {
                            // try for a Japanese display name first.
                            if (displayNames[j].language === language) {
                                return displayNames[j].display;
                            }
                        }
                    } else {
                        // May not always have Japanese language, so just return the english one
                        return displayNames[0].display;
                    }
                    break;
                default:
                    for (j = 0; j < displayNames.length; ++j) {
                        if (displayNames[j].language === 'ENGLISH') {
                            return displayNames[j].display;
                        }
                    }
            }

            return null;
        },
        getDisplayNameByParameterDisplayNames: function (displayNames, language) {
            return this.getDisplayNameByDisplayNames(displayNames, language);
        }
    };
}
